import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

//Organizes the experience data into a MUI accordion

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.secondary.dark,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function ExperienceAccordion(props) {
  const [expanded, setExpanded] = React.useState('panel1');

  const theme = useTheme()

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const renderAccordions = () => {
    //returns a div with all of the logged terminal statements
    const accordions = [];
    let counter = 1;
    props.data.forEach(elem => {

        accordions.push(
            <Accordion expanded={expanded === `panel${counter}`} onChange={handleChange(`panel${counter}`)} >
                <AccordionSummary aria-controls={`panel${counter}d-content`} id={`panel${counter}d-header`}>
                    <Typography sx={{color: theme.palette.info.main}}>{elem.role}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="caption" sx={{color: theme.palette.text.primary}}>{elem.description}</Typography>
                </AccordionDetails>
            </Accordion>)
        counter += 1;
        
    })
    return <div>{accordions}</div>
}


  return (
    <div>
      {renderAccordions()}
    </div>
  );
}
 